import React, {HTMLAttributes} from "react";

/*
penta split:
┌───────────────────────────────┐
│             top               │
├──────┬────────────────┬───────┤
│      │                │       │
│ left │     center     │ right │
│      │                │       │
├──────┴────────────────┴───────┤
│            bottom             │
└───────────────────────────────┘

top, bottom, left and right take the space that they require
center is given the remaining space

*/

export interface PentaSplitProps {
	top?: JSX.Element;
	left?: JSX.Element;
	center: JSX.Element;
	right?: JSX.Element;
	bottom?: JSX.Element;
	outer?: any;
	middle?: any;
	inner?: any;
	rootAttributes?: HTMLAttributes<HTMLDivElement>;
}

export function PentaSplit(props: PentaSplitProps) {
	return <div
		{...props.rootAttributes}
		style={{
			...props.rootAttributes?.style,
			display: "flex",
			flexDirection: "column",
			maxHeight: "100%",
			height: "100%",
		}}
	>
		{props.top}
		
		<div style={{
			minWidth: 0,
			minHeight: 0,
			flexGrow: 1.0,
			display: "flex",
			flexDirection: "row",
			maxHeight: "100%",
			height: "100%",
		}}>
			{props.left}
			
			<div style={{
				minWidth: 0,
				minHeight: 0,
				flexGrow: 1.0,
				maxHeight: "100%",
				height: "100%",
				overflow: "auto",
			}}>
				{props.center}
			</div>
			
			{props.right}
		</div>
		
		{props.bottom}
	</div>;
}

/*
inverse penta split:
┌──────┬────────────────┬───────┐
│      │      top       │       │
│      ├────────────────┤       │
│      │                │       │
│ left │     center     │ right │
│      │                │       │
│      ├────────────────┤       │
│      │     bottom     │       │
└──────┴────────────────┴───────┘

top, bottom, left and right take the space that they require
center is given the remaining space

*/

export function InversePentaSplit(props: PentaSplitProps) {
	return <div style={{
		display: "flex",
		flexDirection: "row",
		maxHeight: "100%",
		height: "100%",
	}}>
		{props.left}
		
		<div style={{
			minWidth: 0,
			flexGrow: 1.0,
			display: "flex",
			flexDirection: "column",
			maxHeight: "100%",
			height: "100%",
		}}>
			{props.top}
			
			<div style={{
				minWidth: 0,
				minHeight: 0,
				flexGrow: 1.0,
				maxHeight: "100%",
				height: "100%",
				overflow: "auto",
			}}>
				{props.center}
			</div>
			
			{props.bottom}
		</div>
		
		{props.right}
	</div>;
}
